import { render, staticRenderFns } from "./PaymentInstructionDialog.vue?vue&type=template&id=cbb5a3e6&"
import script from "./PaymentInstructionDialog.vue?vue&type=script&lang=ts&"
export * from "./PaymentInstructionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports